// TODO: Realized we have a time and date service.  Replace usage of these with that service and remove
export function formatDateRange(start?: string, end?: string): string {
    const options = {timeZone: "UTC", year: "2-digit", month: "2-digit", day: "2-digit"} as const;
  
    const format = (d?: string) => d ? new Intl.DateTimeFormat("en-US", options).format(new Date(d)) : "?";
  
    return start && end && start === end ?
      format(start) :
      `${format(start)} – ${format(end)}`;
  }
  
  export function formatTimeRange(start?: string, end?: string, tz = "America/Chicago"): string {
    const baseOptions = {timeZone: tz, hour: "numeric", minute: "2-digit", hour12: true} as const;
  
    const format = (t?: string, includeZone = false) => {
      if (!t) return "?";
      const date = new Date(`1970-01-01T${t}`);
      const options = includeZone ? {...baseOptions, timeZoneName: "short" as const} : baseOptions;
      return new Intl.DateTimeFormat("en-US", options).format(date);
    };
  
    if (start && end) {
      return `${format(start)} – ${format(end, true)}`;
    } else if (start) {
      return format(start, true);
    } else {
      return "?";
    }
  }
  
  export function formatLocation(raw: string): string {
    if (!raw) return "Unknown";
  
    const parts = raw.split(",").map((p) => p.trim());
  
    // If the last part is "US", remove it and the preceding comma
    if (parts[parts.length - 1]?.toUpperCase() === "US") {
      parts.pop(); // remove "US"
    }
  
    return parts.join(", ");
  }
  